import React from 'react';

function QCStatusPieChart({ qcStats }) {
  if (!qcStats) return null;

  const total = qcStats.passed + qcStats.pending + qcStats.failed;
  if (total === 0) return null;

  const passedPercent = (qcStats.passed / total) * 100;
  const pendingPercent = (qcStats.pending / total) * 100;
  const failedPercent = (qcStats.failed / total) * 100;

  // Simple donut chart using conic gradient
  const gradientStops = [
    `hsl(var(--status-success)) 0% ${passedPercent}%`,
    `hsl(var(--status-warning)) ${passedPercent}% ${passedPercent + pendingPercent}%`,
    `hsl(var(--status-error)) ${passedPercent + pendingPercent}% 100%`
  ].join(', ');

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <h3 className="text-lg font-semibold mb-4">QC Status Distribution</h3>
      
      <div className="flex items-center gap-6">
        {/* Donut Chart */}
        <div className="relative w-32 h-32">
          <div
            className="w-full h-full rounded-full"
            style={{
              background: `conic-gradient(${gradientStops})`,
            }}
          />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 bg-card rounded-full flex items-center justify-center">
              <div className="text-center">
                <div className="text-2xl font-bold">{total}</div>
                <div className="text-xs text-muted-foreground">Total</div>
              </div>
            </div>
          </div>
        </div>

        {/* Legend */}
        <div className="flex-1 space-y-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: 'hsl(var(--status-success))' }} />
              <span className="text-sm">Passed</span>
            </div>
            <span className="text-sm font-semibold">{qcStats.passed} ({passedPercent.toFixed(0)}%)</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: 'hsl(var(--status-warning))' }} />
              <span className="text-sm">Pending</span>
            </div>
            <span className="text-sm font-semibold">{qcStats.pending} ({pendingPercent.toFixed(0)}%)</span>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full" style={{ backgroundColor: 'hsl(var(--status-error))' }} />
              <span className="text-sm">Failed</span>
            </div>
            <span className="text-sm font-semibold">{qcStats.failed} ({failedPercent.toFixed(0)}%)</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default QCStatusPieChart;
